import { render } from "./AssignaTagsView.vue?vue&type=template&id=35c9cdba&scoped=true"
import script from "./AssignaTagsView.vue?vue&type=script&lang=js"
export * from "./AssignaTagsView.vue?vue&type=script&lang=js"

import "./AssignaTagsView.vue?vue&type=style&index=0&id=35c9cdba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c9cdba"]])

export default __exports__